<div class="table-container">
    <app-list-header
    [title]="title"
    [searchPlaceholder]="'tags.search' | translate"
    [searchTerm]="searchTerm | async"
    (searchTermChange)="searchTerm.next($event); searchTags()"
    (clearSearch)="clearFilter()"
    (addNewItem)="createTags()"
  ></app-list-header>
  <table class="table">
      <thead>
          <tr>
              <th class="name-header">
               
              </th>
          </tr>
      </thead>
      <tbody>
          <tr *ngFor="let tag of filteredTags | async" (click)="select(tag)" [class.selected]="tag === selectedTags">
              <td>{{ tag.value }}</td>
              <td>
                  <span [style.color]="tag.color" class="material-icons-outlined">circle</span>
              </td>
          </tr>
      </tbody>
  </table>
</div>